import React, { Component } from 'react';
import { connect } from "react-redux";
import DownloadIcon from '../../../assets/images/downloadIcon.svg';
import SearchIcon from '../../../prat_screen/gt/images/search.svg';
import CustomSelect from "../../../components/common/select/Select";
import ProductMiddleware from "../../../store/prat_middleware/gt/productMiddleware";
import ConsumerPromotionMiddleware from '../../../store/middleware/consumerPromotionMiddleware';
import { compare } from '../../../prat_screen/gt/validation/sort';
import DATA from '../../../assets/data';
import { Loader } from "../../../components/loader";
import './ConsumerPromotionList.styles.scss';
import CustomToast from '../../../util-functions/customToast';
import ConsumerPromotionHistory from '../consumer-promotion-history/ConsumerPromotionHistory';
import HistoryIcon from '../../../assets/images/history.svg';

class ConsumerPromotionList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedBrands: [],
            selectedCategories: [],
            selectedMasterSkus: [],
            myBrands: [],
            myMasterSkus: [],
            selectedConsumerPromotionType: null,
            pageNo: 1,
            selectedYear: new Date().getFullYear(),
            selectedWeekFrom: null,
            selectedWeekTo: null,
            selectedCPStatus: [],
            selectedCodes: [],
            listData: [],
            getData: true,
            activityCode: '',
            isOpen: false
        }
    }

    componentDidMount() {
        this.props.productCategories();
        this.props.productBrands();
        this.props.productMasterSkus();
        this.props.consumerPromotionTypes();
        this.props.consumerPromotionList(
            this.state.pageNo,
            this.state.selectedYear,
            this.state.selectedWeekFrom,
            this.state.selectedWeekTo,
            this.state.selectedCategories,
            this.state.selectedBrands,
            this.state.selectedMasterSkus,
            this.state.selectedCPStatus,
            this.state.selectedConsumerPromotionType,
            this.state.selectedCodes
        );
        this.props.getConsumerPromotionListCount(
            this.state.pageNo,
            this.state.selectedYear,
            this.state.selectedWeekFrom,
            this.state.selectedWeekTo,
            this.state.selectedCategories,
            this.state.selectedBrands,
            this.state.selectedMasterSkus,
            this.state.selectedConsumerPromotionType,
            this.state.selectedCodes
        );
    };

    handleScroll = (e) => {
        const { consumerPromotionListArray } = this.props
        let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 50;
        if (consumerPromotionListArray && bottom && this.state.listData.length < consumerPromotionListArray.total_count) {
            let page = this.state.pageNo + 1;
            this.setState({
                pageNo: page,
                getData: true
            }, () => {
                this.props.consumerPromotionList(
                    page,
                    this.state.selectedYear,
                    this.state.selectedWeekFrom,
                    this.state.selectedWeekTo,
                    this.state.selectedCategories,
                    this.state.selectedBrands,
                    this.state.selectedMasterSkus,
                    this.state.selectedCPStatus,
                    this.state.selectedConsumerPromotionType,
                    this.state.selectedCodes
                );
            })
        }
    };

    handleCategory = category => {
        if (category == null || category.length === 0) {
            this.setState({
                myBrands: [], myMasterSkus: [], selectedCategories: [], selectedBrands: [], selectedMasterSkus: []
            })
        }
        else if (category) {
            let arr = [];
            category.forEach(element => {
                arr.push(element.value);
            });

            this.setState({ selectedCategories: arr, }, () => {
                this.handleFilteredBrands();
            });
        }
    };


    handleFilteredBrands = () => {
        const {
            selectedCategories,
            selectedBrands
        } = this.state;
        const { productBrandsArray } = this.props;
        let filteredbrands = [];
        if (selectedCategories.length) {
            for (let i = 0; i < selectedCategories.length; i++) {
                filteredbrands.push(
                    ...productBrandsArray.filter(item => {
                        return item.Category === selectedCategories[i];
                    })
                );
            }
            let arr = [];
            if (selectedBrands.length) {
                filteredbrands.forEach(item => {
                    if (selectedBrands.includes(item.guid)) {
                        arr.push(item.guid)
                    }
                })
                this.setState({ selectedBrands: arr });
            }

            this.setState({
                myBrands: filteredbrands
            }, () =>
                this.handleFilteredMasterSku()
            );
        }
    };

    handleBrandChange = selectedBrand => {
        if (selectedBrand == null || selectedBrand.length === 0) {
            this.setState({
                myMasterSkus: [], selectedBrands: [], selectedMasterSkus: []
            })

        }
        else if (selectedBrand) {
            let arr = [];
            selectedBrand.forEach(e => {
                arr.push(e.value);
            });

            this.setState({ selectedBrands: arr }, () => {
                this.handleFilteredMasterSku();
            });
        }
    };

    handleFilteredMasterSku = () => {
        const {
            selectedBrands,
            selectedMasterSkus,
        } = this.state;
        const { productMasterSkusArray } = this.props;
        let filteredSkus = [];
        if (selectedBrands.length) {
            for (let i = 0; i < selectedBrands.length; i++) {
                filteredSkus.push(
                    ...productMasterSkusArray.filter(item => {
                        return item.Brand === selectedBrands[i];
                    })
                );
            }

            let arr = [];
            if (selectedMasterSkus.length) {
                filteredSkus.forEach(item => {
                    if (selectedMasterSkus.includes(item.guid)) {
                        arr.push(item.guid)
                    }
                })
                this.setState({ selectedMasterSkus: arr });
            }
            this.setState({
                myMasterSkus: filteredSkus
            });
        }
    };

    handleMasterSkusChange = selectedMasterSku => {
        if (selectedMasterSku == null || selectedMasterSku.length === 0) {
            this.setState({
                selectedMasterSkus: []
            })
        }
        if (selectedMasterSku) {
            let arr = [];
            selectedMasterSku.forEach(e => {
                arr.push(e.value);
            });

            this.setState({ selectedMasterSkus: arr });
        }
    };

    getList = (data) => {
        if (data && this.state.getData) {
            this.setState({
                listData: [...this.state.listData, ...data.results],
                getData: false
            })
        }
    };

    handleCreateConsmerPromotion = () => {
        this.props.createConsumerPromotion({})
    };

    handleConsumerPromotionType = value => {
        if (value) {
            this.setState({ selectedConsumerPromotionType: value.value });
        }
        else {
            this.setState({ selectedConsumerPromotionType: null });
        }
    };

    handleActivityOpen = (item) => {
        window.open(`/consumerpromotionform/?id=${item.guid}`, '_blank')
    };

    handleCPStatusChange = value => {
        if (value == null || value.length === 0) {
            this.setState({
                selectedCPStatus: []
            })
        }
        if (value) {
            let arr = [];
            value.forEach(e => {
                arr.push(e.value);
            });

            this.setState({ selectedCPStatus: arr });
        }
    };

    handleStartWeekChange = (value) => {
        if (value) {
            this.setState({
                selectedWeekFrom: value.value,
                selectedWeekTo: null
            })
        } else {
            this.setState({
                selectedWeekFrom: null,
                selectedWeekTo: null
            })
        }
    };

    handleEndWeekChange = (value) => {
        if (value) {
            this.setState({
                selectedWeekTo: value.value
            })
        } else {
            this.setState({
                selectedWeekTo: null
            })
        }
    };

    handleSubmit = () => {
        this.setState({
            listData: [],
            getData: true
        }, () => {
            this.props.consumerPromotionList(
                1,
                this.state.selectedYear,
                this.state.selectedWeekFrom,
                this.state.selectedWeekTo,
                this.state.selectedCategories,
                this.state.selectedBrands,
                this.state.selectedMasterSkus,
                this.state.selectedCPStatus,
                this.state.selectedConsumerPromotionType,
                this.state.selectedCodes
            );
            this.props.getConsumerPromotionListCount(
                this.state.pageNo,
                this.state.selectedYear,
                this.state.selectedWeekFrom,
                this.state.selectedWeekTo,
                this.state.selectedCategories,
                this.state.selectedBrands,
                this.state.selectedMasterSkus,
                this.state.selectedConsumerPromotionType,
                this.state.selectedCodes
            );
        })
    };

    hanldeActivityCodeInput = (e) => {
        let val = e.target.value;
        if (val) {
            var array = val.split(",");
            this.setState({
                activityCode: val,
                selectedCodes: array,
            });
        } else {
            this.setState({
                activityCode: val,
                selectedCodes: [],
            });
        }
    };

    handleActivityDelete = (id) => {
        this.props.deleteConsumerPromotion(id);
    }

    handleCPHistoryFlag = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.consumerPromotion !== this.props.consumerPromotion) {
            if (this.props.consumerPromotion?.guid) {
                this.props.history.push('/consumerpromotionform/?id=' + this.props.consumerPromotion.guid)
            }
        }

        if (prevProps.consumerPromotionListArray !== this.props.consumerPromotionListArray) {
            this.getList(this.props.consumerPromotionListArray);
        }

        if (prevProps.deleteConsumerPromotionData !== this.props.deleteConsumerPromotionData) {
            if (this.props.deleteConsumerPromotionData?.length === 1) {
                CustomToast('success', 'Promotion deleted successfully!');
                this.handleSubmit();
            }
        }
    };

    render() {
        const { myBrands, selectedBrands, selectedCategories, myMasterSkus, selectedMasterSkus,
            selectedConsumerPromotionType, listData, selectedCPStatus, selectedWeekFrom,
            selectedWeekTo, activityCode, isOpen } = this.state;

        const { productCategoriesArray, productBrandsArray, productMasterSkusArray,
            consumerPromotionTypesArray, isConsumerPromotionListLoading, consumerPromotionListCount } = this.props;

        return (
            <>
                {
                    listData.length === 0 && isConsumerPromotionListLoading
                        ?
                        <Loader flag={true} />
                        :
                        <div className="page-container">
                            <div className="heading-and-download-container">
                                <div className='component-heading' style={{ padding: 0 }}>Consumer Promotion List</div>
                                <div className='df'>
                                    <div className='df alignItem-center cta-cursor' style={{ width: '106px', color: '#3f7fc9', cursor: 'pointer' }} onClick={this.handleCPHistoryFlag}>
                                        <img className='cta-icon' src={HistoryIcon} style={{ marginBottom: '0px', marginRight: '6px' }} alt="" />
                                        <span className='cta-label'><u>See History</u></span>
                                    </div>
                                    <img
                                        style={{ marginLeft: "16px", cursor: "pointer" }}
                                        src={DownloadIcon}
                                        onClick={() => { }}
                                        alt=""
                                    />
                                </div>
                            </div>

                            <div className="header">
                                <div className="headers_controller">
                                    <div className="selectors ">

                                        <CustomSelect.MyCustomSelect
                                            placeholder={"Category"}
                                            allowSelectAll={true}
                                            isDisabled={productCategoriesArray?.length ? false : true}
                                            isMulti
                                            options={
                                                productCategoriesArray
                                                    ? productCategoriesArray?.sort(compare).map(item => ({
                                                        value: item.guid,
                                                        label: item.Name
                                                    }))
                                                    : []
                                            }
                                            onChange={this.handleCategory}
                                            value={
                                                productCategoriesArray
                                                    ? productCategoriesArray
                                                        .filter(item => {
                                                            return selectedCategories.includes(item.guid);
                                                        })
                                                        .map(item => {
                                                            return {
                                                                value: item.guid,
                                                                label: item.Name
                                                            };
                                                        }) : []
                                            }
                                        />

                                        <CustomSelect.MyCustomSelect
                                            placeholder={"Brand"}
                                            allowSelectAll={true}
                                            isDisabled={productBrandsArray?.length ? false : true}
                                            isMulti
                                            options={
                                                myBrands
                                                    ? myBrands.sort(compare).map(item => ({
                                                        value: item.guid,
                                                        label: item.Name
                                                    }))
                                                    : []
                                            }
                                            onChange={this.handleBrandChange}
                                            value={
                                                myBrands
                                                    ? myBrands
                                                        .filter(item => {
                                                            return selectedBrands.includes(item.guid);
                                                        })
                                                        .map(item => {
                                                            return {
                                                                value: item.guid,
                                                                label: item.Name
                                                            };
                                                        }) : []
                                            }
                                        />

                                        <CustomSelect.MyCustomSelect
                                            placeholder={"MSKU"}
                                            allowSelectAll={true}
                                            isDisabled={productMasterSkusArray?.length ? false : true}
                                            isMulti
                                            options={
                                                myMasterSkus
                                                    ? myMasterSkus.sort(compare).map(item => ({
                                                        value: item.guid,
                                                        label: `${item.Description} (${item.Code}) `
                                                    }))
                                                    : []
                                            }
                                            onChange={this.handleMasterSkusChange}
                                            value={
                                                myMasterSkus
                                                    ? myMasterSkus
                                                        .filter(item => {
                                                            return selectedMasterSkus.includes(item.guid);
                                                        })
                                                        .map(item => {
                                                            return {
                                                                value: item.guid,
                                                                label: `${item.Description} (${item.Code}) `
                                                            };
                                                        })
                                                    : []
                                            }
                                        />

                                        <CustomSelect.MyCustomSelect
                                            className="select-box"
                                            placeholder={"CP Type"}
                                            isDisabled={consumerPromotionTypesArray?.length ? false : true}
                                            isClearable={true}
                                            options={
                                                consumerPromotionTypesArray
                                                    ? consumerPromotionTypesArray.map(item => ({
                                                        value: item.guid,
                                                        label: item.Label
                                                    }))
                                                    : []
                                            }
                                            onChange={this.handleConsumerPromotionType}
                                            value={
                                                consumerPromotionTypesArray && selectedConsumerPromotionType
                                                    ? consumerPromotionTypesArray
                                                        .filter(item => {
                                                            return selectedConsumerPromotionType === item.guid;
                                                        })
                                                        .map(item => {
                                                            return {
                                                                value: item.guid,
                                                                label: item.Label
                                                            };
                                                        }) : []
                                            }
                                        />

                                        <CustomSelect.MyCustomSelect
                                            placeholder={"Status"}
                                            allowSelectAll={true}
                                            isMulti
                                            options={DATA.CP_STATUS}
                                            onChange={this.handleCPStatusChange}
                                            value={DATA.CP_STATUS
                                                .filter(item => {
                                                    return selectedCPStatus.includes(item.value);
                                                })
                                                .map(item => {
                                                    return {
                                                        value: item.value,
                                                        label: item.label
                                                    };
                                                })
                                            }
                                        />

                                        <CustomSelect.MyCustomSelect
                                            placeholder="Week Start From"
                                            isClearable={true}
                                            className="select-box"
                                            options={
                                                DATA.WEEK_NO
                                                    .map(item => {
                                                        return {
                                                            value: item.value,
                                                            label: item.label
                                                        };
                                                    })
                                            }
                                            onChange={this.handleStartWeekChange}
                                            value={
                                                DATA.WEEK_NO
                                                    .filter(item => {
                                                        return parseInt(selectedWeekFrom) === parseInt(item.value);
                                                    })
                                                    .map(item => {
                                                        return {
                                                            value: item.value,
                                                            label: item.label
                                                        };
                                                    })
                                            }
                                        />

                                        <CustomSelect.MyCustomSelect
                                            placeholder="Week Start To"
                                            isClearable={true}
                                            className="select-box"
                                            options={
                                                selectedWeekFrom && DATA.WEEK_NO ?
                                                    DATA.WEEK_NO
                                                        .filter(elm => parseInt(elm.value) >= parseInt(selectedWeekFrom))
                                                        .map(item => {
                                                            return {
                                                                value: item.value,
                                                                label: item.label
                                                            };
                                                        })
                                                    : []
                                            }
                                            onChange={this.handleEndWeekChange}
                                            value={
                                                DATA.WEEK_NO
                                                    .filter(item => {
                                                        return parseInt(selectedWeekTo) === parseInt(item.value);
                                                    })
                                                    .map(item => {
                                                        return {
                                                            value: item.value,
                                                            label: item.label
                                                        };
                                                    })
                                            }
                                        />

                                        <div className="search_field">
                                            <input
                                                className="__input_text"
                                                placeholder="Search by Activity Code or ProjectCode"
                                                value={activityCode}
                                                onChange={this.hanldeActivityCodeInput}
                                            />
                                            <img
                                                src={SearchIcon}
                                                className="search_icon"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="headers_action" style={{ justifyContent: 'flex-end' }}>
                                    <div className="control_submit" style={{ textAlign: 'right', width: 'min-content' }} >
                                        <button className="__submit_button" onClick={this.handleSubmit} style={{ marginBottom: '8px' }}>
                                            SUBMIT
                                        </button>
                                        <button
                                            className="create_new"
                                            style={{ outline: 'none' }}
                                            onClick={this.handleCreateConsmerPromotion}
                                        >
                                            + Create New
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: '20px', padding: '16px', backgroundColor: '#fff' }}>
                                <span style={{display:'flex',fontSize:'14px', color:'red'}} >*({consumerPromotionListCount}) finalized promotions does not contain a promo code.</span>
                                <div
                                    className="promotion-list-table-container"
                                    onScroll={e => this.handleScroll(e)}
                                    style={{ marginTop: '8px', padding: 0 }}
                                >

                                    <table className='promotion-list-table'>

                                        <thead>

                                            <tr>

                                                <th
                                                    className='cell-without-white-warp header-cell-bg'
                                                    style={{ textAlign: 'left' }}
                                                >
                                                    Activity Code
                                                </th>
                                                <th
                                                    className='cell-without-white-warp header-cell-bg'
                                                    style={{ textAlign: 'left' }}
                                                >
                                                    Project Code
                                                </th>
                                                <th
                                                    className='promolist-table-cell-padding header-cell-bg'
                                                    style={{ textAlign: 'center' }}
                                                >
                                                    CP Code
                                                </th>
                                                <th
                                                    className='promolist-table-cell-padding header-cell-bg'
                                                    style={{ textAlign: 'center' }}
                                                >
                                                    CP Name
                                                </th>
                                                <th
                                                    className='promolist-table-cell-padding header-cell-bg'
                                                    style={{ textAlign: 'center' }}
                                                >
                                                    Status
                                                </th>
                                                <th
                                                    className='promolist-table-cell-padding header-cell-bg'
                                                    style={{ textAlign: 'center' }}
                                                >
                                                    CP Type
                                                </th>
                                                <th
                                                    className='promolist-table-cell-padding header-cell-bg'
                                                    style={{ textAlign: 'center' }}
                                                >
                                                    Incentive %
                                                </th>
                                                <th
                                                    className='promolist-table-cell-padding header-cell-bg'
                                                    style={{ textAlign: 'center', width: '48px' }}
                                                >
                                                    Week ST & ED
                                                </th>
                                                <th
                                                    className='promolist-table-cell-padding header-cell-bg'
                                                    style={{ textAlign: 'left' }}
                                                >
                                                    Category
                                                </th>
                                                <th
                                                    className='promolist-table-cell-padding header-cell-bg'
                                                    style={{ textAlign: 'left' }}
                                                >
                                                    Brand
                                                </th>
                                                <th
                                                    className='promolist-table-cell-padding header-cell-bg'
                                                    style={{ textAlign: 'left' }}
                                                >
                                                    MSKU
                                                </th>
                                                <th
                                                    className='promolist-table-cell-padding header-cell-bg'
                                                    style={{ textAlign: 'center' }}
                                                >
                                                    Vol Cap
                                                </th>
                                                <th
                                                    className='promolist-table-cell-padding header-cell-bg'
                                                    style={{ textAlign: 'center' }}
                                                >
                                                    View
                                                </th>

                                            </tr>

                                        </thead>

                                        <tbody>

                                            {
                                                listData && listData
                                                    .map(rowItem => (
                                                        <tr className='row-border' key={rowItem.guid}>
                                                            <td
                                                                className='cell-without-white-warp'
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => this.handleActivityOpen(rowItem)}
                                                            >
                                                                {rowItem.ActivityCode ? rowItem.ActivityCode : '--'}
                                                            </td>
                                                            <td
                                                                className='cell-without-white-warp'
                                                            >
                                                                {rowItem.ProjectCodes ? rowItem.ProjectCodes : '--'}
                                                            </td>
                                                            <td
                                                                className='cell-without-white-warp'
                                                            >
                                                                {rowItem.CpCode ? rowItem.CpCode : '--'}
                                                            </td>
                                                            <td
                                                                className='promolist-table-cell-padding'
                                                            >
                                                                {rowItem.CpName ? rowItem.CpName : '--'}
                                                            </td>
                                                            <td
                                                                style={{ textAlign: 'left' }}
                                                                className='promolist-table-cell-padding'
                                                            >
                                                                <span
                                                                    className={
                                                                        rowItem.Status === "Draft"
                                                                            ? "draft-status cp-form-status" :
                                                                            rowItem.Status === "Active"
                                                                                ? "active-status cp-form-status" :
                                                                                rowItem.Status === "DeActivate"
                                                                                    ? 'deactive-status cp-form-status' : 'finalized-status cp-form-status'
                                                                    }
                                                                >
                                                                    {rowItem.Status ? rowItem.Status === 'Active' ? 'Activated' : rowItem.Status === 'DeActivate' ? 'DeActivated' : rowItem.Status : '--'}
                                                                </span>
                                                            </td>
                                                            <td
                                                                className='promolist-table-cell-padding'
                                                                style={{ textAlign: 'left' }}
                                                            >
                                                                {
                                                                    rowItem.CpType ?
                                                                        <span className='cp-type-tab'>
                                                                            {rowItem.CpType}
                                                                        </span>
                                                                        :
                                                                        '--'
                                                                }
                                                            </td>
                                                            <td
                                                                className='promolist-table-cell-padding'
                                                            >
                                                                {rowItem.Incentive ? `${rowItem.Incentive}%` : '--'}
                                                            </td>
                                                            <td
                                                                className='promolist-table-cell-padding'
                                                            >
                                                                {rowItem.WeekStart}-{rowItem.WeekEnd}
                                                            </td>
                                                            <td
                                                                className='promolist-table-cell-padding'
                                                                style={{ textAlign: 'left' }}
                                                            >
                                                                {rowItem.Category ?
                                                                    <span className='cp-list-cat-tab'>
                                                                        {rowItem.Category}
                                                                    </span>
                                                                    :
                                                                    '--'
                                                                }
                                                            </td>
                                                            <td
                                                                className='promolist-table-cell-padding'
                                                                style={{ textAlign: 'left' }}
                                                            >
                                                                {rowItem.Brand ?
                                                                    <span className='cp-list-cat-tab'>
                                                                        {rowItem.Brand}
                                                                    </span>
                                                                    :
                                                                    '--'
                                                                }
                                                            </td>
                                                            <td
                                                                className='promolist-table-cell-padding'
                                                                style={{ textAlign: 'left' }}
                                                            >
                                                                {rowItem.MasterSku ?
                                                                    <span className='cp-list-cat-tab'>
                                                                        {rowItem.MasterSku}
                                                                    </span>
                                                                    :
                                                                    '--'
                                                                }
                                                            </td>
                                                            <td
                                                                className='promolist-table-cell-padding'
                                                            >
                                                                {rowItem.VolumeCap ? rowItem.VolumeCap : '--'}
                                                            </td>
                                                            <td
                                                                className='promolist-table-cell-padding'
                                                            >
                                                                <div className='cp-list-cat-tab cp-view-btn-cont'>
                                                                    <img
                                                                        src={require("../../../prat_screen/gt/images/dots.png")}
                                                                        alt=""
                                                                    />
                                                                    <div className='cp-list-cat-tab cp-view-btn-sub-cont'>
                                                                        <span className='cp-view-btn' onClick={() => this.handleActivityOpen(rowItem)}>view</span>
                                                                        {rowItem.Status === 'Draft' ? <span className='cp-view-btn' onClick={() => this.handleActivityDelete(rowItem.guid)}>delete</span> : null}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                            }

                                        </tbody>
                                    </table>

                                </div>

                            </div>
                        </div>
                }
                {
                    isOpen ?
                        <ConsumerPromotionHistory
                            isOpen={isOpen}
                            flagHandle={this.handleCPHistoryFlag}
                            selectedCategory={selectedCategories}
                            selectedBrand={selectedBrands}
                            selectedMasterSku={selectedMasterSkus}
                        />
                        :
                        null
                }
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        productCategoriesArray: state.ProductReducer.productCategories,
        productBrandsArray: state.ProductReducer.productBrands,
        productMasterSkusArray: state.ProductReducer.productMasterSkus,
        consumerPromotion: state.ConsumerPromotionReducer.consumerPromotion,
        consumerPromotionTypesArray: state.ConsumerPromotionReducer.consumerPromotionTypes,
        consumerPromotionListArray: state.ConsumerPromotionReducer.consumerPromotionList,
        isConsumerPromotionListLoading: state.ConsumerPromotionReducer.isConsumerPromotionListLoading,
        ConsumerPromotionListHasError: state.ConsumerPromotionReducer.ConsumerPromotionListHasError,
        deleteConsumerPromotionIsLoading: state.ConsumerPromotionReducer.deleteConsumerPromotionIsLoading,
        deleteConsumerPromotionData: state.ConsumerPromotionReducer.deleteConsumerPromotion,
        deleteConsumerPromotionHasError: state.ConsumerPromotionReducer.deleteConsumerPromotionHasError,
        consumerPromotionListCount: state.ConsumerPromotionReducer.consumerPromotionListCount,
        isConsumerPromotionListCountLoading: state.ConsumerPromotionReducer.isConsumerPromotionListCountLoading,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        productCategories: () => {
            return dispatch(ProductMiddleware.get_categories());
        },
        productBrands: () => {
            return dispatch(ProductMiddleware.get_brands());
        },
        productMasterSkus: () => {
            return dispatch(ProductMiddleware.get_master_skus());
        },
        createConsumerPromotion: (consumerPromotionObj) => {
            return dispatch(ConsumerPromotionMiddleware.createConsumerPromotion(consumerPromotionObj));
        },
        consumerPromotionTypes: () => {
            return dispatch(ConsumerPromotionMiddleware.consumerPromotionTypes());
        },
        consumerPromotionList: (
            pageNo,
            selectedYear,
            selectedWeekFrom,
            selectedWeekTo,
            selectedCategory,
            selectedBrand,
            selectedMasterSku,
            selectedCPStatus,
            selectedConsumerPromotionType,
            selectedCodes
        ) => {
            return dispatch(ConsumerPromotionMiddleware.consumerPromotionList(
                pageNo,
                selectedYear,
                selectedWeekFrom,
                selectedWeekTo,
                selectedCategory,
                selectedBrand,
                selectedMasterSku,
                selectedCPStatus,
                selectedConsumerPromotionType,
                selectedCodes
            ));
        },
        getConsumerPromotionListCount: (
            pageNo,
            selectedYear,
            selectedWeekFrom,
            selectedWeekTo,
            selectedCategory,
            selectedBrand,
            selectedMasterSku,
            selectedConsumerPromotionType,
            selectedCodes
        ) => {
            return dispatch(ConsumerPromotionMiddleware.getConsumerPromotionListCount(
                pageNo,
                selectedYear,
                selectedWeekFrom,
                selectedWeekTo,
                selectedCategory,
                selectedBrand,
                selectedMasterSku,
                selectedConsumerPromotionType,
                selectedCodes
            ));
        },
        deleteConsumerPromotion: (id) => {
            return dispatch(ConsumerPromotionMiddleware.deleteConsumerPromotion(id));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsumerPromotionList);
